import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MfaService {
  private apiUrl = `${environment.backendUrl}/mfa`;

  constructor(private http: HttpClient) {}

  setup(): Observable<any> {
    return this.http.post(`${this.apiUrl}/setup`, {});
  }

  verifySetup(token: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify-setup`, { token });
  }

  verify(token: string, mfaToken: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify`, { token, mfaToken }, { withCredentials: true });
  }

  recovery(code: string, mfaToken: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/recovery`, { code, mfaToken }, { withCredentials: true });
  }

  disable(token: string): Observable<any> {
    return this.http.request('delete', `${this.apiUrl}/disable`, { body: { token } });
  }
}
